import './styles.scss'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { deleteProcessDetail } from 'redux/smartchat/details/actions'
import { getSmartchat, deleteSmartchat, resetSmartchat, updateCurrentTab, updateModalLoading } from 'redux/smartchat/header/actions'
import { DotsOptionsSelector, HandbookButton } from 'components/common'
import ModalWrapper from 'components/ModalWrapper'
import Processes from './Views/Processes'
import Messages from './Views/Messages'
import { getInfoDoc } from 'utils/statics'
import { lang } from 'utils/helpers'

const SmartChatView = () => {
  const { currentTab, modalLoading, modalError } = useSelector(store => store.smartchatHeader)
  const dispatch = useDispatch()
  const [isOpenOptionsSelector, setIsOpenOptionsSelector] = useState(false)
  const [defaultRestoreModal, setDefaultRestoreModal] = useState({ mode: '', isOpen: false })

  useEffect(() => {
    dispatch(getSmartchat())
    return () => {
      dispatch(deleteProcessDetail())
      dispatch(deleteSmartchat())
    }
  }, [])

  const toggleOptionsSelector = () => setIsOpenOptionsSelector(!isOpenOptionsSelector)

  const toggleDefaultRestoreModal = (mode = '') => {
    if (modalError) dispatch(updateModalLoading(null))
    setDefaultRestoreModal(prevState => ({ ...prevState, mode, isOpen: !prevState.isOpen }))
    if (isOpenOptionsSelector) toggleOptionsSelector()
  }

  return (
    <div className='smartchat-wrapper animated fadeIn'>
      <div className='smartchat custom-scrollbar'>
        <div className='smartchat__header'>
          <div className="smartchat__title">
            <h1>{lang('chatbot_view_title')}</h1>
            <DotsOptionsSelector
              isOpen={isOpenOptionsSelector}
              toggle={toggleOptionsSelector}
              options={[
                {
                  name: lang('chatbot_options_default'),
                  onClick: () => toggleDefaultRestoreModal('default')
                },
                {
                  name: lang('chatbot_options_restore'),
                  onClick: () => toggleDefaultRestoreModal('restore')
                }
              ]}
              position='right'
            />
          </div>
          <HandbookButton
            text={lang('dashboard_you-need-help-configuration')}
            containerClass='smartchat__handbook'
            buttonText={`${lang('dashboard_guide-to')} ${lang('dashboard_smartchat')} (${lang('dashboard_pdf')})`}
            handbookUrl={getInfoDoc('/[nixi1] Manual SmartChat.pdf')}
          />
        </div>
        <div className='smartchat__body'>
          <div className='smartchat__tabs'>
            {['processes', 'messages'].map((tab, index) => (
              <div
                key={index}
                className={`smartchat__tab ${currentTab === tab ? 'smartchat__tab--active' : ''}`}
                onClick={() => dispatch(updateCurrentTab(tab))}
              >
                <span
                  className={`smartchat__tab-text ${currentTab === tab ? 'smartchat__tab-text--active' : ''}`}
                >
                  {lang(`chatbot_tab_${tab}`)}
                </span>
              </div>
            ))}
          </div>
          <div className='smartchat__tab-content'>
            {currentTab === 'processes' && <Processes />}
            {currentTab === 'messages' && <Messages />}
          </div>
        </div>
      </div>
      <ModalWrapper
        isOpen={defaultRestoreModal.isOpen}
        toggle={toggleDefaultRestoreModal}
        eventBtnTxt={lang('dashboard_confirm')}
        eventBtn={() => dispatch(resetSmartchat({ type: defaultRestoreModal.mode, onFinish: toggleDefaultRestoreModal }))}
        cancelBtnTxt={lang('dashboard_cancel')}
        cancelBtn={toggleDefaultRestoreModal}
        isSubmitting={modalLoading}
        error={modalError && lang(modalError.message)}
        contentClassName='smartchat-modal'
        body={
          <div className='modal-content'>
            <p
              dangerouslySetInnerHTML={{
                __html: defaultRestoreModal.mode === 'default'
                  ? lang('smartchat_default_confirm')
                  : lang('smartchat_restore_confirm')
              }}
            ></p>
          </div>
        }
      />
    </div>
  )
}

export default SmartChatView
